<template>
    <v-card class="elevation-0 mb-4">
        <v-card-text
          v-if="!loading && recipientInfo"
          class="pt-6"
        >
            <h2>
               It Seems There Was A Technical Difficulty!
            </h2>
            <p class="body-1 my-3">
              Sorry about the technical difficulty. You can still complete this
              payment by logging into your bank and sending the exact amount to the
              recipient details shown below:
            </p>

            <v-sheet
                tile
                :color="isZelleOrInterac ? '#ffffff' : '#f9f9f9'"
                class="py-6 px-4 grey--text text--darken-3 mx-3 mx-lg-6 mb-6 rounded-lg"
                :class="[{ 'pt-3 mb-12': isZelleOrInterac }]"
            >
                <v-row v-if="recipientInfo" class="position-relative">
                    <component :is="paymentComponent" :recipientInfo="recipientInfo"></component>
                </v-row>
            </v-sheet>

            <v-alert type="warning" class="body-2 mb-0 mx-3 mx-lg-0 px-6" text dense>
                Please note that only complete payments will be accepted.
                Partial and incomplete payments would not be acknowledged as
                received and are unacceptable!
            </v-alert>
        </v-card-text>
    </v-card>
</template>

<script>
    import zelle_payment from '../../match-confirmed-reveal-type-zelle-payment';
    import interac_payment from '../../match-confirmed-reveal-type-interac-payment';
    import faster_payment from '../../match-confirmed-reveal-type-faster-payment';
    import sepa_payment from '../../match-confirmed-reveal-type-sepa-payment';
    import mono_payment from '../../match-confirmed-reveal-type-mono-payment';

    export default {
        props: {
            recipientInfo: Object,
        },
        components: {
            zelle_payment,
            interac_payment,
            faster_payment,
            sepa_payment,
            mono_payment,
        },
        computed: {
            paymentComponent() {
                if (!this.recipientInfo) {
                    return null;
                }

                const { provider, method } = this.recipientInfo;

                return `${method.toLowerCase()}_payment`;
            },
            isZelleOrInterac() {
                if (!this.recipientInfo) {
                    return null;
                }

                const { method } = this.recipientInfo;

                return method === 'ZELLE' || method === 'INTERAC';
            },
        },
    };
</script>
